import React from 'react';
import { useNavigate } from 'react-router-dom';

import logo from '../assets/20.png';
import backdrop from '../assets/landing/backgroundupdated.png';

import './AboutPage.css';

// -------------------- PAGE --------------------
export const AboutPage: React.FC = () => {
  const navigate = useNavigate();
  const handleGetStarted = () => navigate('/login');
  const goHome = () => navigate('/');

  return (
    <div className="dpp-landing dpp-about">
      {/* App meadow backdrop */}
      <div
        className="scene"
        aria-hidden="true"
        style={{ backgroundImage: `url(${backdrop})` }}
      />

      {/* ============ NAV ============ */}
      <nav>
        <div className="wrap nav-inner">
          <div className="brand" onClick={goHome} style={{ cursor: 'pointer' }}>
            <img src={logo} alt="The Dear Parent Project" className="brand-logo" />
          </div>
          <div className="nav-links">
            <a href="/#windows">What it shows</a>
            <a href="/#before">Before you begin</a>
            <a href="/#promise">About us</a>
            <button className="btn honey big" onClick={handleGetStarted}>Get Started</button>
          </div>
        </div>
      </nav>

      {/* ============ FOUNDER NOTE ============ */}
      <header className="about-hero">
        <div className="wrap">
          <div className="letter rise">
            <div className="stamp" aria-hidden="true">
              <span className="heart">
                <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
                  <path d="M13 22C4 15.5 2 11 2 7.5 2 4 4.7 2 7.5 2 9.8 2 11.8 3.3 13 5.3 14.2 3.3 16.2 2 18.5 2 21.3 2 24 4 24 7.5 24 11 22 15.5 13 22Z" fill="#C15A78" />
                </svg>
              </span>
              <span>From<br />the heart</span>
            </div>

            <div className="kicker">A Note From Our Founder</div>
            <h1>Hi, I'm <span className="u">Nandita</span>.</h1>

            <p>The Dear Parent Project started long before it had a name. It started in the ordinary moments of being a mom.</p>

            <p>Watching my child approach something in a way I didn't expect. Seeing strengths that might never show up on a report card. Wondering why something felt easy one day and hard the next. And quietly asking:</p>

            <blockquote className="pullquote">Am I seeing the whole picture?</blockquote>

            <p>I wasn't looking for another test or score. I wanted to understand how my child thought. What made her pause. What made her light up. What helped things click.</p>

            <p>That question became The Dear Parent Project.</p>

            <p>I wanted to create something playful for children and meaningful for parents. Something that asked less <em>"How did they do?"</em> and more <em>"What did we notice?"</em></p>

            <p>But this was never meant to be just about a Learning Snapshot.</p>

            <p>I wanted to create a community too. A place where parents can share what they're noticing, ask the questions we all have, learn from people who understand children, and hear the comforting words: <em>"Mine does that too."</em></p>

            <p>Because understanding our children isn't something we do once. We keep learning them as they grow.</p>

            <p>The Dear Parent Project began with me simply being a mom, trying to understand my child a little better. And that's still at the heart of everything we're building.</p>

            <p className="tagline">A place to stay curious about our children, together.</p>

            <div className="sign-block">
              <div className="sign">Nandita</div>
              <div className="sign-meta">Founder & Mom</div>
              <div className="sign-meta">The Dear Parent Project</div>
            </div>

            <div className="fine">Helping parents notice what matters.</div>
          </div>
        </div>
      </header>

      {/* ============ FOOTER ============ */}
      <footer id="contact">
        <div className="wrap foot-inner">
          <div className="brand" style={{ fontSize: 16 }}>
            <img src={logo} alt="The Dear Parent Project" className="brand-logo" />
          </div>
          <div>
            <a href="/#windows">What it shows</a>
            <a href="/#before">Before you begin</a>
            <a href="/#promise">Our promise</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
